import { z } from 'zod';


export const profileSchema = z.object({
    first_name: z.string().min(2, 'First name is required'),
    job_title : z.string().min(2, 'Job title is required'),
    last_name : z.string().min(2, 'Last name is required'),
    phone     : z.string().min(10, 'Phone number is required'),
});

export type ProfileFormData = z.infer<typeof profileSchema>;
